import { ReactNode } from "react";
import { classNames } from "../utils/class-names";

interface ErrorBannerProps {
  className?: string;
  children?: ReactNode;
}

export function ErrorBanner({
  className,
  children,
}: ErrorBannerProps): JSX.Element {
  return (
    <div
      className={classNames(
        "flex pl-4 items-center border-l-4 rounded-r-lg border-red-400",
        className
      )}
    >
      {children ?? (
        <>
          A system error has occured. Please contact us for assistance if the
          error persists.
        </>
      )}
    </div>
  );
}
